/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Ostatnie powiadomienia w aplikacji',
    titleMeta: 'Wyświetlanie ostatnich powiadomień w aplikacji CamAPS FX',
    descriptionMeta: 'Oto tekst ostatnich powiadomień w aplikacji dotyczących aktualizacji aplikacji, uwag dotyczących bezpieczeństwa i aktualizacji instrukcji obsługi',
    keywords: 'powiadomienia' ,
    localeMeta: 'pl_pl',

    heading: 'Ostatnie powiadomienia w aplikacji',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Aktualizacja aplikacji na Androida (YpsoPump only) 28/10/2026',
    body_132:'Drogi użytkowniku CamAPS FX, nowa wersja aplikacji 1.4(195) będzie dostępna w ciągu najbliższych dni. Proszę wybrać preferowany czas aktualizacji, dezaktywując automatyczną aktualizację dla CamAPS FX w Sklepie Google Play. Jeśli masz pytania, skontaktuj się z obsługą klienta mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Wymagana aktualizacja (tylko YpsoPump) 20/10/2026',
    body_130:'Wymagana aktualizacja! Ta wersja aplikacji CamAPS FX może częściej ulegać awarii i uruchamiać się ponownie. Zaktualizuj aplikację do najnowszej wersji TERAZ za pośrednictwem sklepu Google Play. Wersja aplikacji 1.4(190) zostanie wycofana 20/11/2026. Po tej dacie „Auto mode“ nie będzie dostępny do czasu zaktualizowania aplikacji. Podawanie insuliny za pomocą pompy będzie kontynuowane.',

    header_129:'',
    body_129:'',

    header_128:'Aktualizacja instrukcji obsługi (tylko YpsoPump) 15/10/2026',
    body_128:'Zaktualizowana wersja instrukcji obsługi jest już dostępna. Można uzyskać do niej dostęp z głównego menu CamAPS FX, wybierając Pomoc po zaktualizowaniu aplikacji do najnowszej wersji.',

    header_127:'',
    body_127:'',

    header_126:'Aktualizacja aplikacji na Androida (YpsoPump only) 02/10/2026',
    body_126:'Drogi użytkowniku CamAPS FX, nowa wersja aplikacji 1.4(194) będzie dostępna w ciągu najbliższych dni. Proszę wybrać preferowany czas aktualizacji, dezaktywując automatyczną aktualizację dla CamAPS FX w Sklepie Google Play. Jeśli masz pytania, skontaktuj się z obsługą klienta mylife-Diabetescare.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'Aktualizacja aplikacji iOS (YpsoPump only) 28/09/2026',
    body_122:'Drogi użytkowniku CamAPS FX, nowa wersja aplikacji 1.4(196) będzie dostępna w ciągu najbliższych kilku dni. DEZAKTYWUJ AUTOMATYCZNE AKTUALIZACJE CamAPS FX w App Store, aby wybrać preferowany czas aktualizacji. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta mylife-Diabetescare.',

    header_121:'Wydanie Apple iOS 27 11/09/2026',
    body_121:'Apple wkrótce wyda iOS 27. Aby zapewnić nieprzerwane korzystanie z aplikacji CamAPS FX, PRZED aktualizacją iPhone\'a do iOS 27 sprawdź na stronie internetowej producenta sensora zgodność smartfona i systemu operacyjnego. Automatyczne aktualizacje mogą być domyślnie WŁĄCZONE w ustawieniach telefonu; rozważ ich WYŁĄCZENIE.',

    header_120:'',
    body_120:'',

    header_119:'Aktualizacja instrukcji obsługi (tylko YpsoPump) 10/09/2026',
    body_119:'Zaktualizowana wersja instrukcji obsługi jest już dostępna. Można uzyskać do niej dostęp z głównego menu CamAPS FX, wybierając Pomoc po zaktualizowaniu aplikacji do najnowszej wersji.',

    header_118:'Aktualizacja aplikacji na Androida (YpsoPump only) 07/09/2026',
    body_118:'Drogi użytkowniku CamAPS FX, nowa wersja aplikacji 1.4(193) będzie dostępna w ciągu najbliższych dni. Proszę wybrać preferowany czas aktualizacji, dezaktywując automatyczną aktualizację dla CamAPS FX w Sklepie Google Play. Jeśli masz pytania, skontaktuj się z obsługą klienta mylife-Diabetescare.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Dezaktywacja wersji Android poniżej 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Drogi użytkowniku CamAPS FX, ze względów cyberbezpieczeństwa wersje PONIŻEJ 1.4(192) zostaną WYCOFANE w dniu 31/08/2026. Upewnij się, że aplikacja została ZAKTUALIZOWANA do wersji 1.4(192) przed tą datą. W razie pytań skontaktuj się z obsługą klienta mylife-Diabetescare.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Wydanie Android OS 17 24/06/2026',
    body_109:'Android wkrótce wyda OS 17. Aby zapewnić nieprzerwane korzystanie z aplikacji CamAPS FX, PRZED aktualizacją urządzenia z systemem Android do OS 17 sprawdź na stronie internetowej producenta sensora zgodność smartfona i systemu operacyjnego. Automatyczne aktualizacje mogą być domyślnie WŁĄCZONE w ustawieniach telefonu; WYŁĄCZ JE.',

    header_108:'',
    body_108:'',

    header_107:'',
    body_107:'',

    header_106:'Aktualizacja instrukcji obsługi (tylko YpsoPump) 22/06/2026',
    body_106:'Zaktualizowana wersja instrukcji obsługi jest już dostępna. Można uzyskać do niej dostęp z głównego menu CamAPS FX, wybierając Pomoc.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'',
    body_103:'',

    header_102:'Dexcom G7 jest dostępny (tylko YpsoPump; iOS & Android) 11/06/2026',
    body_102:'Integracja systemu CGM Dexcom G7 jest już dostępna! Użytkownicy przechodzący z Dexcom G6 znajdą więcej informacji oraz przegląd kompatybilnych systemów CGM na naszej stronie internetowej: www.mylife-diabetescare.com.',

    header_101:'Dexcom G7 jest dostępny (tylko YpsoPump; iOS & Android) 09/06/2026',
    body_101:'Obsługa Dexcom G7 już wkrótce! W ciągu najbliższych kilku dni rozpoczniemy stopniowe udostępnianie integracji z systemem CGM Dexcom G7. Aby sprawdzić, czy funkcja jest już dostępna dla Ciebie, otwórz ekran parowania CGM w swojej aplikacji. Użytkownicy przechodzący z systemu Dexcom G6 mogą znaleźć dodatkowe informacje na naszej stronie internetowej, w tym przegląd kompatybilnych systemów CGM: www.mylife-diabetescare.com.',

    header_100:'Aktualizacja aplikacji Android (tylko Ypsopump) 05/06/2026',
    body_100:'Drogi użytkowniku CamAPS FX, nowa wersja CamAPS FX, 1.4(192), będzie dostępna w ciągu najbliższych dni. Aby wybrać moment aktualizacji, wyłącz AUTOMATYCZNE AKTUALIZACJE w Google Play Store. Użytkownicy z wersją NIŻSZĄ niż OS 13 NIE będą mogli ZAKTUALIZOWAĆ CamAPS FX do tej wersji. Zaktualizowana wersja instrukcji obsługi jest już dostępna. W razie pytań prosimy o kontakt z obsługą klienta mylife-Diabetescare.',

    header_99:'',
    body_99:'',

    header_98:'Zakończenie obsługi starych systemów operacyjnych 22/05/2026',
    body_98:'Przygotowując kolejną aktualizację aplikacji, należy pamiętać, że CamAPS FX będzie obsługiwana WYŁĄCZNIE na telefonach kompatybilnych z sensorami, działających w systemie OS 13 lub nowszym albo Apple iOS 18 lub nowszym. Po tej aktualizacji do najnowszej wersji użytkownicy telefonów z systemem NIŻSZYM niż OS 13 lub iOS 18 NIE będą mogli AKTUALIZOWAĆ ani PONOWNIE INSTALOWAĆ CamAPS FX.',

    header_97:'Aktualizacja aplikacji iOS 22/05/2026',
    body_97:'Drogi użytkowniku CamAPS FX, nowa wersja CamAPS FX, 1.4(195), będzie dostępna w ciągu najbliższych dni. Aby wybrać moment aktualizacji, wyłącz AUTOMATYCZNE AKTUALIZACJE w App Store. Użytkownicy z wersją NIŻSZĄ niż Apple iOS 18 NIE będą mogli ZAKTUALIZOWAĆ CamAPS FX do tej wersji. Zaktualizowana wersja instrukcji obsługi jest już dostępna. W razie pytań prosimy o kontakt z obsługą klienta mylife-Diabetescare.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'Dezaktywacja wersji iOS poniżej 1.4(193) (tylko Ypsopump) 22/04/2026',
    body_93:'Drogi użytkowniku CamAPS FX, ze względów cyberbezpieczeństwa WERSJE PONIŻEJ 1.4(193) zostaną DEZAKTYWOWANE 30 kwietnia. Upewnij się, że Twoja aplikacja jest ZAKTUALIZOWANA do wersji 1.4(193) przed tą datą. W razie pytań skontaktuj się z Działem Obsługi Klienta mylife-Diabetescare.',

    header_92:'Wycofanie starych systemów operacyjnych 21/04/2026',
    body_92:'Ze względów cyberbezpieczeństwa od 30 czerwca 2026 r. mylife CamAPS FX będzie obsługiwany WYŁĄCZNIE na telefonach kompatybilnych z sensorem, działających na następujących systemach operacyjnych: Android OS 13 lub nowszy oraz Apple iOS 18 lub nowszy. Użytkownicy systemów operacyjnych PONIŻEJ Android OS 13 lub Apple iOS 18 NIE będą mogli AKTUALIZOWAĆ ani PONOWNIE INSTALOWAĆ mylife CamAPS FX po tej dacie.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'Dezaktywacja wersji iOS poniżej 1.4(193) (tylko Ypsopump) 16/03/2026',
    body_87:'Drogi użytkowniku CamAPS FX, ze względów cyberbezpieczeństwa WERSJE PONIŻEJ 1.4(193) zostaną DEZAKTYWOWANE 31 marca. Upewnij się, że Twoja aplikacja jest ZAKTUALIZOWANA do wersji 1.4(193) przed tą datą. W razie pytań skontaktuj się z Działem Obsługi Klienta mylife-Diabetescare.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Aktualizacja aplikacji Android (tylko Ypsopump) 02/02/2026',
    body_82:'Drogi użytkowniku CamAPS FX, w ciągu najbliższych dni będzie dostępna NOWA WERSJA aplikacji – 1.4(190). WYŁĄCZ AUTOMATYCZNE AKTUALIZACJE CamAPS FX w sklepie Google Play, aby móc wybrać preferowany czas aktualizacji. Ze względów cyberbezpieczeństwa WERSJE PONIŻEJ 1.4(190) zostaną WYCOFANE 31 marca. W razie pytań skontaktuj się z Działem Obsługi Klienta mylife-Diabetescare.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'Wiadomość od mylife-Diabetescare (tylko YpsoPump) 17/12/2025',
    body_77:'Ważna informacja! Istotne jest, aby od dziś uzupełniać swoje zbiorniki. Ma to zapewnić ciągłość terapii dla wszystkich. Dziękujemy za Państwa wsparcie.',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Wiadomość z mylife-Diabetescare (tylko YpsoPump) 09/12/2025',
    body_74:'Zbiornik mylife YpsoPump można ponownie napełnić jeden raz  w ciągu 7 dni od pierwszego napełnienia.Dowiedz się więcej na stronie Zbiornik w serwisie mylife-diabetescare.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'',
    body_70:'',
    body_70_link_text:'',
    body_70_end: '',
    body_70_link:'',
	
    header_69:'Aktualizacja aplikacji iOS (tylko YpsoPump) 25/11/2025',
    body_69:'Drogi użytkowniku mylife CamAPS FX, NOWA WERSJA aplikacji będzie dostępna w ciągu najbliższych kilku dni. DEZAKTYWUJ AUTOMATYCZNE AKTUALIZACJE CamAPS FX w App Store, aby wybrać preferowany czas aktualizacji. Twoja obecna wersja ZOSTANIE ZAKOŃCZONA 9 grudnia 2025. Jeśli masz jakiekolwiek pytania, skontaktuj się z Obsługą Klienta Ypsomed.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'KOMUNIKAT DOTYCZĄCY BEZPIECZEŃSTWA STOSOWANIA PRODUKTU 28/10/2025',
    body_62:'Proszę przeczytać tę ważną informację ostrzegawczą',
    body_62_link_text:'N-0125',
    body_62_end: '. Przejdź do menu aplikacji -> Powiadomienia o bezpieczeństwie i otwórz odnośnik do powiadomienia o bezpieczeństwie.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+PL+final.pdf',

    header_61:'Aktualizacja aplikacji iOS (tylko YpsoPump) 02/10/2025',
    body_61:'Aby uzyskać optymalną wydajność aplikacji, zaktualizuj swoje mylife CamAPS FX do NAJNOWSZEJ WERSJI (1.4(192)) za pośrednictwem sklepu Apple App.',

    header_60:'',
    body_60:'',

    header_59:'Aktualizacja aplikacji iOS (tylko YpsoPump) 22/09/2025',
    body_59:'Drogi użytkowniku mylife CamAPS FX, nowa wersja aplikacji będzie dostępna w ciągu najbliższych kilku dni. DEZAKTYWUJ AUTOMATYCZNE AKTUALIZACJE CamAPS FX w App Store, aby wybrać preferowany czas aktualizacji. Nowa wersja podręcznika użytkownika będzie dostępna. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta Ypsomed.',

    header_58:'Wydanie iOS 26 (tylko YpsoPump) 13/09/2025',
    body_58:'Apple wkrótce wyda iOS 26. Aby zapewnić nieprzerwaną obsługę aplikacji mylife CamAPS FX, sprawdź stronę internetową producenta czujnika, aby zweryfikować zgodność smartfona i systemu operacyjnego przed zaktualizowaniem iPhone\'a do iOS 26. Uwaga: Automatyczne aktualizacje mogą być domyślnie włączone w ustawieniach telefonu, proszę je wyłączyć.',

    header_57:'Aktualizacja aplikacji na Androida (tylko YpsoPump) 26/08/2025',
    body_57:'Drogi użytkowniku mylife CamAPS FX, nowa wersja aplikacji będzie dostępna w ciągu najbliższych 2 do 3 dni. Proszę wybrać preferowany czas aktualizacji, dezaktywując automatyczną aktualizację dla CamAPS FX w Sklepie Google Play. Nowa wersja instrukcji obsługi będzie dostępna. Jeśli masz pytania, skontaktuj się z obsługą klienta Ypsomed.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Zakończenie starszych wersji aplikacji 01/07/2025',
    body_49:'Obecna wersja przestanie działać 1 sierpnia 2025 roku. Zaktualizuj swoją aplikację do najnowszej wersji dostępnej w Google Play.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Ze względów cyberbezpieczeństwa, od 1 sierpnia 2025 roku, mylife CamAPS FX będzie obsługiwany tylko na telefonach kompatybilnych z czujnikami z systemem Android 12 i nowszym. Użytkownicy systemów operacyjnych poniżej OS 12 nie będą mogli aktualizować ani ponownie instalować mylife CamAPS FX po tej dacie.',

    header_47:'Wydanie iOS (tylko YpsoPump) 09/06/2025',
    body_47:'Aplikacja mylife CamAPS FX jest teraz dostępna również na iPhony! Jeśli rozważają Państwo przejście na system iOS, prosimy odwiedzić sekcję „Ważne informacje dla użytkowników systemu iOS” na stronie www.mylife-diabetescare.com/pl-PL/system-mylife-loop.html.',

    header_46:'',
    body_46:'',

    header_45:'Android OS 16 09/06/2025',
    body_45:'Aby zapewnić nieprzerwane korzystanie z aplikacji mylife CamAPS FX, proszę sprawdzić stronę internetową producenta czujnika stężenia glukozy w celu zweryfikowania kompatybilności przed aktualizacją do systemu Android OS 16. Uwaga: Automatyczne aktualizacje mogą być domyślnie włączone w ustawieniach Twojego telefonu.',

    header_44:'Aktualizacja instrukcji obsługi 20/05/2025',
    body_44:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'Nowa aktualizacja (18/03/2025)',
    body_40:'Szanowny użytkowniku mylife CamAPS FX, Nowa wersja aplikacji będzie gotowa w ciągu najbliższych 48 godzin. Aby wybrać preferowany czas aktualizacji, wyłącz automatyczną aktualizację dla CamAPS FX w Google Play Store. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta Ypsomed.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Zakończenie obsługi starej wersji aplikacji (tylko Ypsopump)',
    body_37:'Obecna wersja przestanie działać 7 lutego 2025 roku. Zaktualizuj swoją aplikację do najnowszej wersji dostępnej w Google Play.',

    header_36:'Nowa wersja aplikacji 06/01/2025',
    body_36:'Szanowny użytkowniku mylife CamAPS FX, Nowa wersja aplikacji będzie gotowa w ciągu najbliższych 48 godzin. Aby wybrać preferowany czas aktualizacji, wyłącz automatyczną aktualizację dla CamAPS FX w Google Play Store. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta Ypsomed.',
	
	header_35:'OS 8 & 9 11/10/2024',
    body_35:'Ze względów cyberbezpieczeństwa, od 1 stycznia 2025 roku, mylife CamAPS FX będzie obsługiwany tylko na telefonach kompatybilnych z czujnikami z systemem Android 10 i nowszym. Użytkownicy systemów operacyjnych poniżej OS 10 nie będą mogli aktualizować ani ponownie instalować mylife CamAPS FX po tej dacie. Przypomnienie, system nie jest jeszcze kompatybilny z OS15',
	
	header_34:'',
    body_34:'',
	
	header_33:'Ogłoszenie o planowanej konserwacji 05/12/2024',
    body_33:'Z powodu zaplanowanej konserwacji chmury usługi CamAPS FX, funkcjonalność Companion będzie niedostępna 7 grudnia od godziny 10:00 GMT przez około trzy godziny. Przepraszamy za wszelkie niedogodności, które mogą wyniknąć z tej sytuacji.',
	
	header_32:'Aktualizacja instrukcji obsługi 11/05/2024',
    body_32:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',
	
	header_31:'Nowa wersja aplikacji 17/11/2024',
    body_31:'Szanowny użytkowniku mylife CamAPS FX, Nowa wersja aplikacji będzie gotowa w ciągu najbliższych 48 godzin. Aby wybrać preferowany czas aktualizacji, wyłącz automatyczną aktualizację dla CamAPS FX w Google Play Store. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta Ypsomed.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Ze względów cyberbezpieczeństwa, od 1 stycznia 2025 roku, mylife CamAPS FX będzie obsługiwany tylko na telefonach kompatybilnych z czujnikami z systemem Android 10 i nowszym. Użytkownicy systemów operacyjnych poniżej OS 10 nie będą mogli aktualizować ani ponownie instalować mylife CamAPS FX po tej dacie.',
	
	header_29:'Nowa wersja aplikacji 09/10/2024',
    body_29:'Szanowny użytkowniku mylife CamAPS FX, Nowa wersja aplikacji będzie gotowa w ciągu najbliższych 48 godzin. Aby wybrać preferowany czas aktualizacji, wyłącz automatyczną aktualizację dla CamAPS FX w Google Play Store. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta Ypsomed.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Ze względów cyberbezpieczeństwa, od 1 stycznia 2025 roku, mylife CamAPS FX będzie obsługiwany tylko na telefonach kompatybilnych z czujnikami z systemem Android 10 i nowszym. Użytkownicy systemów operacyjnych poniżej OS 10 nie będą mogli aktualizować ani ponownie instalować mylife CamAPS FX po tej dacie.',

	header_27:'',
    body_27:'',
	
	header_26:'Aktualizacja instrukcji obsługi 11/05/2024',
    body_26:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',
	
	header_25:'Aktualizacja instrukcji obsługi 05/05/2024',
    body_25:'Szanowny użytkowniku mylife CamAPS FX, Nowa wersja aplikacji będzie gotowa w ciągu najbliższych 24 godzin. Aby wybrać preferowany czas aktualizacji, wyłącz automatyczną aktualizację dla CamAPS FX w Google Play Store. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta Ypsomed.',
	
	header_24:'',
    body_24:'',
	
	header_23:'Nowa wersja aplikacji 24/04/2024',
    body_23:'Szanowny użytkowniku mylife CamAPS FX, Nowa wersja aplikacji będzie gotowa w ciągu najbliższych 24 godzin. Aby wybrać preferowany czas aktualizacji, wyłącz automatyczną aktualizację dla CamAPS FX w Google Play Store. Jeśli masz jakiekolwiek pytania, skontaktuj się z obsługą klienta Ypsomed.',
	
	header_22:'Aktualizacja instrukcji obsługi 21/04/2024',
    body_22:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Aktualizacja instrukcji obsługi 04/03/2024',
    body_16:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',
	
	header_15:'Aktualizacja instrukcji obsługi 04/01/2024',
    body_15:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',
	
	header_14:'Android OS 14. 22/11/2023',
    body_14:'Przypomnienie: Aby zapewnić nieprzerwane korzystanie z aplikacji mylife CamAPS FX, proszę sprawdzić stronę internetową producenta czujnika stężenia glukozy w celu zweryfikowania kompatybilności przed aktualizacją do systemu Android OS 14. Uwaga: Automatyczne aktualizacje mogą być domyślnie włączone w ustawieniach Twojego telefonu.',
	
	header_13:'KOMUNIKAT DOTYCZĄCY BEZPIECZEŃSTWA STOSOWANIA PRODUKTU 14/11/2023',
    body_13:'KOMUNIKAT DOTYCZĄCY BEZPIECZEŃSTWA STOSOWANIA PRODUKTU ',
    body_13_link_text:'Proszę przeczytać tę ważną informację ostrzegawczą',
    body_13_end: '. Przejdź do menu aplikacji -> Powiadomienia o bezpieczeństwie i otwórz odnośnik do powiadomienia o bezpieczeństwie.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+final+-+PL.pdf',

	header_12:'Aktualizacja instrukcji obsługi 10/11/2023',
    body_12:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',
	
	header_11:'Android OS 14. 12/09/2023',
    body_11:'Aby zapewnić nieprzerwane korzystanie z aplikacji mylife CamAPS FX, proszę sprawdzić stronę internetową producenta czujnika stężenia glukozy w celu zweryfikowania kompatybilności przed aktualizacją do systemu Android OS 14. Uwaga: Automatyczne aktualizacje mogą być domyślnie włączone w ustawieniach Twojego telefonu.Upewnij się, że korzystasz z aplikacji mylife CamAPS FX w wersji 1.4(173) przed aktualizacją do systemu Android OS 14.',
	
	header_10:'KOMUNIKAT DOTYCZĄCY BEZPIECZEŃSTWA STOSOWANIA PRODUKTU 15/08/2023',
    body_10:'KOMUNIKAT DOTYCZĄCY BEZPIECZEŃSTWA STOSOWANIA PRODUKTU Proszę przeczytać tę ważną informację ostrzegawczą. Przejdź do menu aplikacji -> Powiadomienia o bezpieczeństwie i otwórz odnośnik do powiadomienia o bezpieczeństwie.',
	
	header_9:'Aktualizacja instrukcji obsługi 27/07/2023',
    body_9:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',
	
	header_8:'',
    body_8:'',
	
	header_7:'Samsung A-Series 14/07/2023',
    body_7:'Użytkownicy modeli Samsung A-Series (np. A53, A33) mogli doświadczyć utraty sygnału ze swojego czujnika CGM po najnowszej aktualizacji nakładki Samsung One UI 5.1. Samsung zidentyfikował ten problem i rozwiązanie jest obecnie w trakcie opracowywania. Samsung planuje wydać aktualizację One UI w dniu 24 lipca (w zależności od Twojego regionu), która rozwiąże problem utraty sygnału. Zaleca się zainstalowanie aktualizacji, gdy stanie się dostępna. Jeśli nie zaktualizowałeś jeszcze do wersji One UI 5.1, zalecamy zaczekać na kolejną aktualizację Samsung One UI.',

    header_6:'',
    body_6:'',

    header_5:'',
    body_5:'',

    header_4:'Aktualizacja instrukcji obsługi 27/05/2023',
    body_4:'Dostępna jest zaktualizowana wersja instrukcji obsługi.',

    header_3:'Alerty SMS (Tylko Ypsopump) 11/05/2023',
    body_3:'Wiadomość:Wraz z nadchodzącą w połowie maja aktualizacją 1.4(171) będzie można aktywować do 5 obserwatorów SMS i jednocześnie korzystać z trybu Companion. Korzystanie z trybu Companion wymaga, aby telefon użytkownika miał połączenie internetowe dla udostępniania danych. Użytkownicy muszą mieć kartę SIM do wysyłania SMS-ów z ich telefonu. Korzystającym z jednej z tych opcji, zalecamy sprawdzenie czy plan taryfowy pokrywa koszty SMS-ów i/lub transmisji danych w zależności od używanej opcji.',

    header_2:'Aktualizacja cyberbezpieczeństwa (Tylko Ypsopump) 24/04/2023',
    body_2:'Bezpieczeństwo aplikacji mylife CamAPS FX jest niezwykle ważne. Od połowy maja będzie miała miejsce aktualizacja cyberbezpieczeństwa wymuszona przez Google Play Store. Po tej aktualizacji niewielka część telefonów może nie przejść kontroli integralności cyberbezpieczeństwa. Możesz przetestować swój telefon z wyprzedzeniem, odwiedzając menu pomocy i wypełniając kontrolę. Jeśli telefon nie przejdzie tego testu, spróbuj odinstalować i ponownie zainstalować aplikację.',

    header_1:'',
    body_1:'',
};
